//NEW: UI_REVAMP
const isThirdPartyLogin = sessionStorage.getItem('isThirdPartyLogin') === 'true';
export const menuItems = (isAgent) =>
	[
		{
			name: 'Transaction',
			icon: '/assets/icons/transaction.svg',
			path: '/transaction',
		},
		{
			name: 'History',
			icon: '/assets/icons/history.svg',
			path: '/history',
		},
		{
			name: 'Result',
			icon: '/assets/icons/result.svg',
			path: '/result',
		},
		{
			name: 'Prize',
			icon: '/assets/icons/prize.svg',
			path: '/prize',
		},
		isAgent &&
			!isThirdPartyLogin && {
				name: 'Claimed Ticket',
				icon: '/assets/icons/claimedticket.svg',
				path: '/claimedticket',
			},
		!isThirdPartyLogin && {
			name: 'Credit Withdrawal',
			icon: '/assets/icons/creditwithdrawal.svg',
			path: '/creditwithdrawal',
		},
		isAgent &&
			!isThirdPartyLogin && {
				name: 'Reports',
				icon: '/assets/icons/reports.svg',
				path: '/report',
			},
		{
			name: 'Profile',
			icon: '/assets/icons/profile.svg',
			path: '/profile',
		},
	].filter(Boolean);

export const betMenu = (handleBetNavigation) => {
	return [
		{
			isPath: window.location.pathname === '/pcso',
			name: 'PCSO',
			onClick: () => handleBetNavigation(1, '/pcso'),
		},
		{
			isPath: window.location.pathname === '/stl',
			name: 'STL',
			onClick: () => handleBetNavigation(2, '/stl'),
		},
	];
};
